/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  ProductDraftsUserControllerDiscardMutationResponse,
  ProductDraftsUserControllerDiscardPathParams,
  ProductDraftsUserControllerDiscard401,
  ProductDraftsUserControllerDiscard404,
  ProductDraftsUserControllerDiscard409,
} from '../types/ProductDraftsUserControllerDiscard.ts';

function getProductDraftsUserDiscardUrl(id: ProductDraftsUserControllerDiscardPathParams['id']) {
  const res = { method: 'DELETE', url: `/api/user/product-drafts/${id}` as const };
  return res;
}

/**
 * {@link /api/user/product-drafts/:id}
 */
export async function productDraftsUserDiscard(
  id: ProductDraftsUserControllerDiscardPathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    ProductDraftsUserControllerDiscardMutationResponse,
    ResponseErrorConfig<
      | ProductDraftsUserControllerDiscard401
      | ProductDraftsUserControllerDiscard404
      | ProductDraftsUserControllerDiscard409
    >,
    unknown
  >({ method: 'DELETE', url: getProductDraftsUserDiscardUrl(id).url.toString(), ...requestConfig });
  return res.data;
}
